import { useEffect } from 'react';

const StructuredData = () => {
  useEffect(() => {
    // Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "GlowApp",
      "url": process.env.REACT_APP_SITE_URL || "https://www.glowapp.me",
      "logo": `${process.env.REACT_APP_SITE_URL || "https://www.glowapp.me"}/logo.png`,
      "description": "Complete appointment management solution for beauty salons, spas, and clinics",
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Service",
        "email": "support@glowapp.me"
      },
      "sameAs": [
        // Add social media links here when available
      ]
    };

    // WebSite Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "GlowApp",
      "url": "https://www.glowapp.me",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://www.glowapp.me/search?q={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    };

    // SoftwareApplication Schema
    const softwareSchema = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "GlowApp",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "iOS, Android, Web",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "150"
      }
    };

    // Service Schema
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Appointment Management Software",
      "provider": {
        "@type": "Organization",
        "name": "GlowApp"
      },
      "areaServed": "Worldwide",
      "description": "Complete appointment management solution for beauty businesses"
    };

    // LocalBusiness Schema (for local SEO) - Only add if contact phone is configured
    const contactPhone = process.env.REACT_APP_CONTACT_PHONE;
    const localBusinessSchema = contactPhone ? {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "GlowApp",
      "description": "Appointment management platform for beauty businesses",
      "url": process.env.REACT_APP_SITE_URL || "https://www.glowapp.me",
      "telephone": contactPhone,
      "email": "support@glowapp.me",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Global",
        "addressCountry": "Worldwide"
      },
      "priceRange": "$$",
      "openingHours": "Mo-Su 00:00-23:59"
    } : null;

    // BreadcrumbList Schema
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": process.env.REACT_APP_SITE_URL || "https://www.glowapp.me"
        }
      ]
    };

    // Add all schemas to page (filter out null values)
    const schemas = [
      organizationSchema, 
      websiteSchema, 
      softwareSchema, 
      serviceSchema, 
      localBusinessSchema, 
      breadcrumbSchema
    ].filter(schema => schema !== null);
    
    schemas.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `structured-data-${index}`;
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    // Cleanup on unmount
    return () => {
      schemas.forEach((_, index) => {
        const script = document.getElementById(`structured-data-${index}`);
        if (script) {
          script.remove();
        }
      });
    };
  }, []);

  return null;
};

export default StructuredData;
